import { FC } from 'react';
import { styled } from '@mui/system';

const Body = styled('div')(() => ({
  fontFamily: 'Arial',
  lineHeight: '1.4',
  '& p': {
    display: 'block',
    width: '100%',
    wordWrap: 'break-word',
    margin: 'revert',
  },
  '& ul, li, ol': {
    padding: 'revert',
  },
  '& iframe, video, img': {
    maxWidth: '100%',
  },
  '& video, img': {
    height: 'auto !important',
  },
  '& img[style*="width:auto"], video[style*="width:auto"]': {
    width: 'revert-layer !important',
  },
}));

export type HTMLBodyProps = {
  body: string;
};

export const HTMLBody: FC<HTMLBodyProps> = props => {
  const { body } = props;

  const parser = new DOMParser();
  const content = parser.parseFromString(body, 'text/html');
  const anchors = content.getElementsByTagName('a');

  Array.from(anchors).forEach(a => {
    a.setAttribute('target', '_blank');
    a.setAttribute('rel', 'noreferrer');
  });

  return <Body dangerouslySetInnerHTML={{ __html: content.body.innerHTML }} />;
};

export default HTMLBody;
